import React from 'react';

import AirlineLogo from '../../../../Airline/AirlineLogo/AirlineLogo';

import classes from './FlightInfoBoxInnerLeft.scss';

const flightInfoBoxInnerLeft = (props) => {

    return (
        <div className={classes.Box}>
            <div className={classes.FlightAirlines}>
                <AirlineLogo airlineCode={props.airlineCode} />
                <p>
                    <span>
                        {props.operatingAirline}: {props.flightNumberInitial}-{props.flightNumberDigit}
                    </span>
                    <span className="u-fontSize11">{props.aircraftName}</span>
                    <span className={classes.ClassType}>{props.classType}</span>
                    <span className={classes.FlightStatus}>
                        {props.flightStatus === "1" ? "Refundable" : "Non Refundable"}
                    </span>
                </p>
            </div>
        </div>
    );
}

export default flightInfoBoxInnerLeft;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoBoxInnerLeft/FlightInfoBoxInnerLeft.js